import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Tab, Tabs } from '@material-ui/core';
import TabPanel from 'components/common/tab/TabPanel';
import { useTranslation } from 'react-i18next';
import { a11yProps } from 'lib/library';
import { T } from 'components/common/text';
import cx from 'classnames';
import { lowerCase } from 'lodash';
import { ProjectContext } from 'contexts/project/ProjectContext';
import { fileExtensionList } from 'lib/mapper';

interface ProjectInfoFilesProps {}

function ProjectInfoFiles({}: ProjectInfoFilesProps) {
  const { t } = useTranslation();

  const [fileTab, setFileTab] = useState<number>(0);
  const fileTabList = [t('GLOBAL_LOCAL'), t('GLOBAL_GROUP'), t('GLOBAL_PARTNER')];

  const { partnerFileListCt, cloudFileListCt, localFileListCt } = useContext(ProjectContext);

  return (
    <Styled.ProjectInfoFiles data-component-name="ProjectInfoFiles">
      <div className="projectInfoFiles__wrapper">
        <div className="ProjectInfoFiles__label">
          <T>PROJECT_UPLOADED_FILES</T>
        </div>
        <Tabs
          value={fileTab}
          onChange={(e: any, value: any) => setFileTab(value)}
          aria-label="infoFileTab"
          className="projectInfoFiles__tabs"
        >
          {fileTabList.map((item, idx) => (
            <Tab
              className={cx('projectInfoFiles__tab_item', lowerCase(item))}
              key={idx}
              label={item}
              disableRipple
              {...a11yProps(idx, 'fileTab')}
            />
          ))}
        </Tabs>
        <TabPanel
          value={fileTab}
          index={0}
          name="infoFileTab"
          className="projectInfoFiles__tabpanel local"
        >
          <div className="projectInfoFiles__tabpanel_box">
            {localFileListCt.value.map((item: any, idx: number) => {
              const itemType = item.type || '';
              const extensionSrc = fileExtensionList.includes(itemType.toLocaleLowerCase())
                ? require(`static/images/icons/icon_extension_${itemType.toLocaleLowerCase()}.svg`)
                : require(`static/images/icons/icon_extension_etc.svg`);
              return (
                <div key={idx} className="ProjectInfoFiles__tab_row ">
                  <img src={extensionSrc} alt={item.type} />
                  <div className="text-overflow-ellipsis filename">{item.name}</div>
                </div>
              );
            })}
          </div>
        </TabPanel>
        <TabPanel
          value={fileTab}
          index={1}
          name="infoFileTab"
          className="projectInfoFiles__tabpanel group"
        >
          <div className="projectInfoFiles__tabpanel_box">
            {cloudFileListCt.value?.map((item: any, idx: number) => {
              const itemType = item.type || '';
              const extensionSrc = fileExtensionList.includes(itemType.toLocaleLowerCase())
                ? require(`static/images/icons/icon_extension_${itemType.toLocaleLowerCase()}.svg`)
                : require(`static/images/icons/icon_extension_etc.svg`);
              return (
                <div key={idx} className="ProjectInfoFiles__tab_row ">
                  <img src={extensionSrc} alt={item.type} />
                  <div className="text-overflow-ellipsis filename">{item.originName}</div>
                </div>
              );
            })}
          </div>
        </TabPanel>
        <TabPanel
          value={fileTab}
          index={2}
          name="infoFileTab"
          className="projectInfoFiles__tabpanel partner"
        >
          <div className="projectInfoFiles__tabpanel_box">
            {partnerFileListCt.value?.map((item: any, idx: number) => {
              const itemType = item.type || '';
              const extensionSrc = fileExtensionList.includes(itemType.toLocaleLowerCase())
                ? require(`static/images/icons/icon_extension_${itemType.toLocaleLowerCase()}.svg`)
                : require(`static/images/icons/icon_extension_etc.svg`);
              return (
                <div key={idx} className="ProjectInfoFiles__tab_row ">
                  <img src={extensionSrc} alt={item.type} />
                  <div className="text-overflow-ellipsis filename">{item.originName}</div>
                </div>
              );
            })}
          </div>
        </TabPanel>
      </div>
    </Styled.ProjectInfoFiles>
  );
}

export default React.memo(ProjectInfoFiles);

const Styled = {
  ProjectInfoFiles: styled.div<{}>`
    position: relative;
    .projectInfoFiles__wrapper {
      width: 480px;
      .ProjectInfoFiles__label {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .projectInfoFiles__tabs {
        width: 272px;
        min-height: 30px;
        border-radius: 2px 2px 0 0;
        border: 1px solid #e1e1e7;
        border-bottom: none;
        .MuiTabs-indicator {
          display: none;
        }
        .projectInfoFiles__tab_item {
          text-transform: capitalize;
          border-right: none;
          min-width: 90px;
          min-height: 30px;
          padding: 0;
          font-weight: 400;
          &.group {
            border-left: 1px solid #e1e1e7;
            border-right: 1px solid #e1e1e7;
          }
          &.Mui-selected {
            background-color: #00a6e2;
            border-bottom: none;
            color: #fff;
          }
        }
        .projectInfoFiles__align_wrapper {
          border: 1px solid #000;
          display: flex;
          justify-content: flex-end;
          width: 100%;
          .projectInfoFiles__align_box {
            display: flex;
            .projectInfoFiles__align {
              background-color: yellow;
            }
          }
        }
      }

      .projectInfoFiles__tabpanel {
        border: 1px solid #e1e1e7;
        border-radius: 0 2px 2px 2px;
        height: 200px;
        padding: 5px 0 5px 10px;
        .projectInfoFiles__tabpanel_box {
          width: 100%;
          padding: 5px 0;
          height: 190px;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;
          row-gap: 8px;
          .ProjectInfoFiles__tab_row {
            height: 20px;
            display: flex;
            align-items: center;
            img {
              width: 21px;
              height: 21px;
              margin-right: 10px;
            }
            .filename {
              width: 410px;
              font-size: 13px;
              font-weight: 400;
              color: #444;
              line-height: 20px;
            }
          }
        }
      }
    }
  `,
};
